import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_ctx.confirmationShown)
    ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
        key: 0,
        acceptTheme: "primary",
        rejectTheme: "return",
        subtitleStyle: "red",
        titleText: `Please confirm trailer is not fit for duty. </br> The ${_ctx.assistanceCompany} team will be notified.`,
        subtitleText: "Confirmation cannot be undone!",
        acceptText: "Confirmed, trailer is not fit for duty.",
        rejectText: "Go back",
        onAccept: _ctx.onAccept,
        onReject: _ctx.onReject
      }, null, 8, ["titleText", "onAccept", "onReject"]))
    : _createCommentVNode("", true)
}